import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const DotMenuHorizontalIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M9.16632 8.00033C9.16614 8.6444 8.64438 9.16617 8.00031 9.16634C7.35608 9.16634 6.83349 8.64451 6.83331 8.00033C6.83331 7.356 7.35597 6.83334 8.00031 6.83334C8.64449 6.83351 9.16632 7.3561 9.16632 8.00033Z"
      fill="currentColor"
    />
    <path
      d="M13.833 8.00033C13.8328 8.6444 13.3111 9.16617 12.667 9.16634C12.0228 9.16634 11.5002 8.64451 11.5 8.00033C11.5 7.356 12.0227 6.83334 12.667 6.83334C13.3112 6.83351 13.833 7.3561 13.833 8.00033Z"
      fill="currentColor"
    />
    <path
      d="M4.49969 8.00033C4.49952 8.6444 3.97775 9.16617 3.33368 9.16634C2.68946 9.16634 2.16686 8.64451 2.16669 8.00033C2.16669 7.356 2.68935 6.83334 3.33368 6.83334C3.97786 6.83351 4.49969 7.3561 4.49969 8.00033Z"
      fill="currentColor"
    />
  </svg>
);
